// Perfis de usuario (espelha backend/src/helpers/Perfil.ts).
//  - admin:    tudo.
//  - operador: igual ao admin, menos criar/excluir usuarios, o Link do SMS
//              e as telas de Fluxos Visuais e Chatbot IA. Nao tem saudacao.
//  - user:     usuario comum.

export const ROTULO_PERFIL = {
  admin: "Administrador",
  operador: "Operador",
  user: "Usuário Comum",
};

export const COR_PERFIL = {
  admin: { fundo: "#fef2f2", texto: "#dc2626", fundoEscuro: "rgba(239, 68, 68, 0.15)", textoEscuro: "#f87171" },
  operador: { fundo: "#fff7ed", texto: "#ea580c", fundoEscuro: "rgba(249, 115, 22, 0.16)", textoEscuro: "#fb923c" },
  user: { fundo: "#eff6ff", texto: "#2563eb", fundoEscuro: "rgba(59, 130, 246, 0.15)", textoEscuro: "#60a5fa" },
};

export const ehAdmin = (perfil) => perfil === "admin";
export const ehOperador = (perfil) => perfil === "operador";
export const poderDeAdmin = (perfil) => perfil === "admin" || perfil === "operador";
export const rotuloPerfil = (perfil) => ROTULO_PERFIL[perfil] || ROTULO_PERFIL.user;
